<script setup>
import { computed } from 'vue'

const props = defineProps({
  paths: { type: [String, Array], required: true },
  mode: { type: String, default: 'fill' },
})

const pathList = computed(() => (Array.isArray(props.paths) ? props.paths : [props.paths]))
</script>

<template>
  <svg
    class="app-icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      v-for="path in pathList"
      :key="path"
      :d="path"
      :fill="mode === 'fill' ? 'currentColor' : 'none'"
      :stroke="mode === 'stroke' ? 'currentColor' : 'none'"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped>
.app-icon {
  display: block;
  width: 1em;
  height: 1em;
  flex: 0 0 auto;
}
</style>
